import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import textSlicerFunction, {validateNumChars} from 'notebook/tables/excess/util/textSlicerFunction';

export default {
  ...textSlicerFunction,
  name: 'RIGHT',
  shortDescription: 'Substring from the end of a specified string.',
  description: 'Returns a substring from the end of a specified string.',
  params: [
    {
      ...textSlicerFunction.params[0],
      description: 'The string from which the right portion will be returned.',
    },
    {
      ...textSlicerFunction.params[1],
      description:
        'The number of characters to return from the right side of string. Equals 1 if not specified.',
    },
  ],
  eval: (text: string, numChars?: number): string => {
    validateNumChars('RIGHT', numChars);
    numChars ??= 1;
    return text.slice(Math.max(0, text.length - numChars));
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
